var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayer1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.76 58C45.6658 58 58.56 45.1058 58.56 29.2C58.56 13.2942 45.6658 0.400024 29.76 0.400024C13.8542 0.400024 0.959961 13.2942 0.959961 29.2C0.959961 45.1058 13.8542 58 29.76 58Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3871 12.4769C22.6847 11.8433 23.3231 11.4401 24.0191 11.4401H31.7327C32.3663 11.4401 32.9519 11.7665 33.2783 12.3089L49.6607 39.4673C49.9967 40.0193 49.9967 40.7057 49.6799 41.2577C49.3583 41.8193 48.7583 42.1601 48.1151 42.1601H40.0511C39.5759 42.1601 39.1151 41.9777 38.7743 41.6417C35.7791 38.7761 32.0015 36.8609 27.9215 36.1361C23.3519 35.4017 17.9663 36.4049 12.6671 41.6417C12.0479 42.2465 11.0831 42.3329 10.3679 41.8433C9.65274 41.3537 9.39834 40.4177 9.76314 39.6353L22.3775 12.4769H22.3823H22.3871ZM27.1583 15.0017L41.0879 38.5889H44.9471L30.7151 15.0113H27.1583V15.0017ZM34.4783 34.4657L24.2159 17.0801L16.0175 34.7153C19.8335 32.6561 24.2255 31.9217 28.5023 32.6273C30.6527 32.9633 32.6687 33.6401 34.4783 34.4657Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.6,
    height: 57.6,
    fill: "white",
    transform: "translate(0.959961 0.400024)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer1);
export default __webpack_public_path__ + "static/media/Layer_1.224059ac2f99824be5d77a7bc9f33400.svg";
export { ForwardRef as ReactComponent };